import { useAuthContext } from './AuthProvider';
/**
 * Main authentication hook
 * Provides access to authentication state and methods
 */
export const useAuth = () => {
    return useAuthContext();
};
//# sourceMappingURL=useAuth.js.map